export const INSTITUTION_ROLE_OPTIONS = [
  { value: 'institution_admin', label: 'Institution Administrator' },
  { value: 'security_admin_delegate', label: 'Security Administrator Delegate' },
  { value: 'executive_oversight', label: 'Executive Oversight' },
  { value: 'compliance_auditor', label: 'Compliance Auditor' },
];

export const RETENTION_SUBJECT_OPTIONS = [
  { value: 'read_only_reviewer', label: 'Executive Oversight', hint: 'Post-close read-only access for active Executive Oversight members' },
  { value: 'compliance_auditor', label: 'Compliance Auditor', hint: 'Post-close read-only access for active Compliance Auditor members' },
];

export const ACCESS_MODE_OPTIONS = [
  { value: 'full', label: 'Full access' },
  { value: 'operational_only', label: 'Operational only' },
  { value: 'read_only', label: 'Read-only' },
  { value: 'deny', label: 'Deny login' },
];

export const LICENSE_FEATURE_OPTIONS = [
  { value: 'reports', label: 'Reports' },
  { value: 'iot', label: 'IoT' },
  { value: 'api_connections', label: 'API connections' },
  { value: 'foresight', label: 'ForeSight' },
  { value: 'scenario_marketplace', label: 'Scenario marketplace' },
  { value: 'partners', label: 'Partners' },
];

export const labelForOption = (options, value) => (
  options.find((option) => option.value === value)?.label
  || String(value || '').replace(/_/g, ' ')
);
